import { getNamespace } from '../../utils/storage';
import * as api from './GeneralApi';

export const getGenericList =
    (listName, service = api.getGenericList) =>
    async (dispatch) => {
        const namespace = getNamespace();
        return await service(listName, namespace)?.then((response) => {
            let propertyName = '';
            switch (listName) {
                case 'nationality':
                    propertyName = 'nationalities';
                    break;
                case 'city':
                    propertyName = 'cities';
                    break;
                case 'arrival_mode':
                    propertyName = 'arrivalModes';
                    break;
                case 'insurance_type':
                    propertyName = 'insuranceTypes';
                    break;
                case 'admission_type':
                    propertyName = 'admissionTypes';
                    break;
                default:
                    propertyName = 'nationalities';
                    break;
            }
            dispatch({
                type: 'LOAD_GENERICS',
                payload: response.data.items,
                listName: propertyName
            });
        });
    };
export const clearMessage = () => (dispatch) => {
    dispatch({
        type: 'ADD_MESSAGE',
        payload: null
    });
};
export const addMessage =
    ({ text, status }) =>
    (dispatch) => {
        if (text && status) {
            dispatch({
                type: 'ADD_MESSAGE',
                payload: {
                    text,
                    status
                }
            });
        }
    };
